import * as React from 'react'
import { create } from 'zustand'
import { devtools } from 'zustand/middleware'

export interface IuseStickyNav {
    isSticky: boolean
    setIsSticky: (isSticky: boolean) => void
    space: string
    isTabsSticky: boolean
    setIsTabsSticky: (isTabsSticky: boolean) => void
}

const createStickyNavStore = (name: string) => {
    const stickyNavStore = create<IuseStickyNav>()(
        devtools(
            (set, get) => ({
                space: 'scroll-mt-[180px]',
                isSticky: false,
                setIsSticky: (isSticky) => set({ isSticky }),
                isTabsSticky: false,
                setIsTabsSticky: (isTabsSticky) => set({ isTabsSticky }),
            }),
            { name }
        )
    )

    return stickyNavStore
}

export default createStickyNavStore
